import CityPageTemplate from "../city-template/CityPageTemplate";
import { puertoRicoConfig } from "./data";

export default function PuertoRicoPage() {
  return <CityPageTemplate config={puertoRicoConfig} />;
}